"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScrollDirection = exports.Scroll = void 0;
const react_1 = require("react");
const throttle_1 = __importDefault(require("lodash/throttle"));
var Scroll;
(function (Scroll) {
    Scroll[Scroll["IDLE"] = 0] = "IDLE";
    Scroll[Scroll["DOWN"] = 1] = "DOWN";
    Scroll[Scroll["UP"] = 2] = "UP";
    Scroll[Scroll["REACH_BOTTOM"] = 3] = "REACH_BOTTOM";
})(Scroll = exports.Scroll || (exports.Scroll = {}));
function isScrolledToBottom(scrollElement) {
    if (scrollElement) {
        return scrollElement.scrollTop + scrollElement.clientHeight >= scrollElement.scrollHeight - 1;
    }
    const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
    const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    // The tolerance is set to 0.001 which means that if the difference between value
    // and 1.0 is less than 0.001, the function will return true.
    // This is an extra calibration since sometimes, winScroll / height is not equal to 1.
    const tolerance = 0.001;
    return Math.abs(winScroll / height - 1.0) < tolerance;
}
/**
 * a custom hook that returns scroll direction
 */
function useScrollDirection(mobilePageContainerRef) {
    const [scrollDirection, setScrollDirection] = (0, react_1.useState)(Scroll.IDLE);
    const pageContainer = mobilePageContainerRef?.current ?? undefined;
    (0, react_1.useEffect)(() => {
        const scrollElement = pageContainer || window;
        let lastScrollY = pageContainer?.scrollTop || window.pageYOffset;
        const updateScrollDirection = (0, throttle_1.default)(() => {
            const scrollY = pageContainer?.scrollTop || window.pageYOffset;
            let direction = scrollY > lastScrollY ? Scroll.DOWN : Scroll.UP;
            if (isScrolledToBottom(pageContainer)) {
                direction = Scroll.REACH_BOTTOM;
                setScrollDirection(direction);
            }
            else if (direction !== scrollDirection &&
                (scrollY - lastScrollY > 10 || scrollY - lastScrollY < -10)) {
                setScrollDirection(direction);
            }
            lastScrollY = scrollY > 0 ? scrollY : 0;
        }, 400);
        scrollElement.addEventListener("scroll", updateScrollDirection); // add event listener
        return () => {
            scrollElement.removeEventListener("scroll", updateScrollDirection); // clean up
        };
    }, [pageContainer, scrollDirection]);
    return scrollDirection;
}
exports.useScrollDirection = useScrollDirection;
//# sourceMappingURL=hooks.js.map